import { render, staticRenderFns } from "./StatusOrder.vue?vue&type=template&id=79a2ea98&lang=pug&"
import script from "./StatusOrder.vue?vue&type=script&lang=js&"
export * from "./StatusOrder.vue?vue&type=script&lang=js&"
import style0 from "./StatusOrder.vue?vue&type=style&index=0&id=79a2ea98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports